import axios from 'axios';
import { toast } from 'react-toastify';
import { getClaimHeaders, headers, enrollmentHeader } from 'src/utils';
import {
  getHospitalDetailsUrl,
  postHospitalDetailsUrl,
  getClaimCountURL,
  getApproveOverdueUrl,
  fetchSearchByStatus,
  postActionReconcileURL,
  getOPResellers,
  downloadClaimExcelURL,
  uploadClaimExcelURL,
  getEmailCount,
  viewJSONRecord,
  getSettlementHistoryURL,
  postFoDocURL,
  getAllClaimCountURL,
  getReviewerTypesURL,
  getReviewerListURL,
  fetchCustomerDetailsURL,
  fetchStateListURL,
  fetchHospitalListURL,
  fetchCitiesListURL,
  addHospitalURL,
  fetchBankListURL,
  addBankURL,
  getDraftClaimURL,
  DeleteDraftClaimURL,
  submitClaimURL,
  claimPutURL,
  claimPostURL,
  uploadDocumentURL,
  getClaimDocURL,
  deleteClaimDocUrl,
  getEligibleReviewersUrl,
  fetchNewCustomerInfoURL,
  getResellersURL,
  fetchActionReportCountURL,
  fetchActionReportDetailURL,
  fetchExternalStatusURL,
  fetchReviewerRolesURL,
  downloadReviewerClaimsURL,
  getRmURL,
  fetchConsolidatedReimbursementURL,
  downloadConsolidatedReimbursementReportURL,
  fetchTATStatusReimbursementURL,
  fetchTATDataReimbursementURL,
  downloadTATReportURL,
  getClaimInfo,
  getNewClaimStatuses,
  raiseStatusDowngradeURL,
  getDowngradeRequestsURL,
  fetchStatusDowngradeRequestURL,
  fetchReviewerIdByRoleURL,
  updateClaimStatusURL,
  getDowngradeRequestHistoryURL,
  getPennyDropRecordsURL,
  getPennyDropRecordsExcelURL
} from '../constants';
import {
  DeleteApi,
  Fetch,
  GetApi,
  PostApi,
  PutApi
} from 'src/services/middleware';
import * as XLSX from 'xlsx';

export const getHospitalDetails = async (name, cityId) => {
  try {
    const res = await GetApi(
      `${getHospitalDetailsUrl(name, cityId)}`,
      headers()
    );
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const createHospitalDetails = async (data) => {
  try {
    const res = await PostApi(`${postHospitalDetailsUrl}`, data, headers());
    if (res?.status == 200) {
      if (res?.data?.code === 400) {
        return res?.data;
      }
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getClaimCount = async () => {
  try {
    const res = await GetApi(`${getClaimCountURL}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const approveOverdueClaim = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      `${getApproveOverdueUrl(claimId, subClaimId)}`,
      headers()
    );
    if (res.status == 200) {
      toast.success('Claim approved successfully');
      return res;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getSearchClaimStatus = async () => {
  try {
    const res = await GetApi(`${fetchSearchByStatus()}`, headers());
    if (res.data?.code == 200) {
      return res.data?.data;
    } else {
      return [];
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const postActionReconcile = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      `${postActionReconcileURL(claimId, subClaimId)}`,
      headers()
    );
    if (res.data?.code == 200) {
      toast.success(res?.data?.message);
      return res.data;
    } else {
      toast.error(res?.data?.message);
      return [];
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getOPResellerName = async () => {
  try {
    const res = await GetApi(`${getOPResellers}`, headers());
    if (res.status == 200) {
      return res?.data?.data;
    } else {
      return [];
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getEligibleReviewersApi = async (claimId, subClaimID) => {
  try {
    const res = await GetApi(
      `${getEligibleReviewersUrl(claimId, subClaimID)}`,
      headers()
    );

    if (res.status == 200) {
      return res?.data?.data;
    } else {
      return [];
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

function s2ab(s) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}

export const getDownloadClaimExcel = async (payload, type) => {
  try {
    if (payload.mode === 'download') {
      const requestOptions = {
        method: 'POST',
        headers: headers().headers,
        body: JSON.stringify(payload),
        redirect: 'follow'
      };

      const res = await Fetch(`${downloadClaimExcelURL}`, requestOptions);
      if (!res) {
        return;
      }
      const blob = await res.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'data.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    } else {
      const res = await PostApi(`${viewJSONRecord}`, payload, headers());
      if (res.status == 200) {
        return res.data;
      } else {
        toast.error('something went wrong');
      }
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const uploadClaimExcel = async (params) => {
  try {
    const formData = new FormData();
    formData.append('file', params.file, 'excel.xlsx');
    formData.append('emailRecipients', params.emailRecipients);
    formData.append('id', params.batchId);
    const requestOptions = {
      method: 'POST',
      headers: getClaimHeaders(),
      body: formData,
      redirect: 'follow'
    };
    let response = await Fetch(uploadClaimExcelURL, requestOptions);
    let res = await response.json();
    if (res.code == 200) {
      toast.success('Excel Upload Successfully', { position: 'top-center' });
      return response;
    }
  } catch (err) {
    toast.error('something went wrong', { position: 'top-center' });
  }
};

export const getSettlementHistory = async (claimId, subClaimID) => {
  try {
    const res = await GetApi(
      `${getSettlementHistoryURL(claimId, subClaimID)}`,
      headers()
    );
    if (res.status == 200) {
      return res?.data?.data;
    } else {
      return [];
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};
export const uploadFODoc = async (claimId, subClaimId, data) => {
  try {
    const formData = new FormData();
    formData.append('file', data);
    const res = await PostApi(
      `${postFoDocURL(claimId, subClaimId)}`,
      formData,
      enrollmentHeader()
    );
    if (res.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getAllClaimCount = async () => {
  try {
    const res = await GetApi(`${getAllClaimCountURL}`, headers());
    if (res.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

// Hierarchy claim bucket
export const getReviewerTypes = async (status) => {
  try {
    const res = await GetApi(`${getReviewerTypesURL(status)}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getReviewerList = async (type) => {
  try {
    const res = await GetApi(`${getReviewerListURL(type)}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

//RaiseReimbursement
export const fetchCustomerClaimDetails = async (id) => {
  try {
    const res = await GetApi(`${fetchCustomerDetailsURL(id)}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchHospitalsList = async (payload) => {
  try {
    const res = await PostApi(fetchHospitalListURL, payload, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchStateList = async () => {
  try {
    const res = await GetApi(`${fetchStateListURL}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchCitiesList = async (payload) => {
  try {
    const res = await PostApi(`${fetchCitiesListURL}`, payload, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const addHospitalAPI = async (payload) => {
  try {
    const res = await PostApi(`${addHospitalURL()}`, payload, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchBanksList = async (payload) => {
  try {
    const res = await PostApi(`${fetchBankListURL}`, payload, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchDraftClaim = async (payload) => {
  try {
    const res = await PostApi(getDraftClaimURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const addBankAPI = async (payload) => {
  try {
    const res = await PostApi(`${addBankURL}`, payload, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const DeleteDraftClaim = async (payload) => {
  try {
    const res = await PostApi(DeleteDraftClaimURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const submitClaim = async (claimId, id) => {
  const res = await PutApi(submitClaimURL(claimId, id), null, headers());
  if (res.status == 200) {
    return res.data;
  } else {
    return res;
  }
};

export const ApiPutClientId = async (claimId, subClaimId, data) => {
  const res = await PutApi(claimPutURL(claimId, subClaimId), data, headers());
  if (res.status == 200) {
    return res.data;
  } else {
    return res;
  }
};

export const ApiPostClientId = async (data) => {
  const res = await PostApi(claimPostURL, data, headers());
  if (res.status == 200) {
    return res.data;
  } else {
    return res;
  }
};

export const uploadClaimDocuments = async (
  docId,
  claimId,
  file,
  docChecks,
  resellerId
) => {
  const token = localStorage.getItem('token');
  const auth_token = localStorage.getItem('auth_token');
  try {
    var formdata = new FormData();
    file.forEach((f, index) => {
      formdata.append('file', f);
    });
    if (docChecks) {
      formdata.append('documentIds', docChecks);
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        Authorization: `Token ${token}`,
        'Auth-Token': auth_token
      },
      body: formdata
    };

    let response = await fetch(
      uploadDocumentURL(claimId, docId, resellerId),
      requestOptions
    );
    if (response.status === 401) {
      toast.error('You have been logged out.');
    }
    let json = await response.json();

    return json;
  } catch (e) {
    if (e.name !== 'AbortError') {
      return { status: 'error', code: 0, message: e };
    } else {
      return { status: 'aborted' };
    }
  }
};

export const getClaimDoc = async (claimId, subClaimId) => {
  const res = await GetApi(getClaimDocURL(claimId, subClaimId), headers());
  if (res.status == 200) {
    return res.data;
  } else {
    return res;
  }
};

export const deleteClaimDoc = async (docId) => {
  const res = await DeleteApi(deleteClaimDocUrl(docId), headers());
  if (res.status == 200) {
    return res.data;
  } else {
    return res;
  }
};

export const fetchNewCustomerClaimsDetails = async (payload) => {
  try {
    const res = await PostApi(fetchNewCustomerInfoURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchResellerDetails = async (payload) => {
  try {
    const res = await PostApi(getResellersURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchActionReportCount = async (payload) => {
  try {
    const res = await PostApi(fetchActionReportCountURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchActionReportDetail = async (payload) => {
  try {
    const res = await PostApi(fetchActionReportDetailURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchExternalStatus = async () => {
  try {
    const res = await GetApi(`${fetchExternalStatusURL}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchReviewerRoles = async () => {
  try {
    const res = await GetApi(`${fetchReviewerRolesURL}`, headers());
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const DownloadReviewerClaims = async (payload) => {
  try {
    const res = await PostApi(downloadReviewerClaimsURL, payload, headers());

    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchRmDetails = async (payload) => {
  try {
    const res = await PostApi(getRmURL, payload, headers());
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchConsolidatedReimbursement = async (payload) => {
  try {
    const res = await PostApi(
      fetchConsolidatedReimbursementURL,
      payload,
      headers()
    );
    if (res.status == 200) {
      return res.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const downloadConsolidatedReimbursementReport = async (payload) => {
  try {
    const res = await PostApi(
      downloadConsolidatedReimbursementReportURL,
      payload,
      {
        ...headers(),
        responseType: 'blob'
      }
    );
    if (res.status == 200) {
      return res;
    }
  } catch (err) {
    toast.error('Something went wrong');
  }
};

export const fetchTATDataReimbursement = async (payload) => {
  try {
    const res = await PostApi(fetchTATDataReimbursementURL, payload, headers());
    if (res?.status == 200) {
      return res?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};
export const fetchTATStatusReimbursement = async () => {
  try {
    const res = await GetApi(`${fetchTATStatusReimbursementURL}`, headers());
    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};
export const DownloadTATReport = async (payload) => {
  try {
    const res = await PostApi(downloadTATReportURL, payload, {
      ...headers(),
      responseType: 'blob'
    });
    if (res?.status == 200) {
      return res;
    }
  } catch (err) {
    toast.error('Something went wrong');
  }
};

//claim status downgrade workflow
export const fetchClaimInformation = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(`${getClaimInfo(claimId, subClaimId)}`, headers());

    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchNewClaimStatuses = async () => {
  try {
    const res = await GetApi(`${getNewClaimStatuses()}`, headers());

    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const raiseClaimStatusDowngradeRequest = async (data) => {
  try {
    const res = await PostApi(`${raiseStatusDowngradeURL()}`, data, headers());
    if (res?.status == 200) {
      return res?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchDowngradeRequestRecords = async (data) => {
  try {
    const res = await PostApi(`${getDowngradeRequestsURL()}`, data, headers());
    if (res?.status == 200) {
      return res?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getClaimStatusDetails = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      `${fetchStatusDowngradeRequestURL(claimId, subClaimId)}`,
      headers()
    );
    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const fetchUsersByRole = async (claimId, subClaimId) => {
  try {
    const res = await GetApi(
      `${fetchReviewerIdByRoleURL(claimId, subClaimId)}`,
      headers()
    );
    if (res?.status == 200) {
      return res?.data?.data;
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const updateClaimStatus = async (claimId, subClaimId, data) => {
  const res = await PutApi(
    updateClaimStatusURL(claimId, subClaimId),
    data,
    headers()
  );
  if (res.status == 200) {
    return res.data;
  } else {
    return res;
  }
};

export const getDowngradeRequestHistory = async (claimId, subClaimID) => {
  try {
    const res = await GetApi(
      `${getDowngradeRequestHistoryURL(claimId, subClaimID)}`,
      headers()
    );
    if (res.status == 200) {
      return res?.data?.data;
    } else {
      return [];
    }
  } catch (err) {
    toast.error('something went wrong');
  }
};

export const getPennyDropReportData = async (data) => {
  try {
    const res = await PostApi(`${getPennyDropRecordsURL}`, data, headers());
    if (res?.status == 200) {
      return res?.data;
    }
  } catch (err) {
    toast.error('something went wrong', err);
  }
};

export const getPennyDropReportExcel = async (payload) => {
  try {
    const requestOptions = {
      method: 'POST',
      headers: headers().headers,
      body: JSON.stringify(payload),
      redirect: 'follow'
    };

    const res = await Fetch(`${getPennyDropRecordsExcelURL}`, requestOptions);
    if (!res) return;

    const blob = await res.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    const now = new Date();
    const timestamp = `${String(now.getMinutes()).padStart(2, '0')}${String(
      now.getSeconds()
    ).padStart(2, '0')}`;

    link.download = `PennyDropReport_${timestamp}.xlsx`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (err) {
    toast.error('Download failed');
  }
};
